export default {
  50: '#F2FCFA',
  100: '#DAF5ED',
  200: '#BBEDDF',
  300: '#93DBC7',
  400: '#69C2A8',
  500: '#34AD8B',
  600: '#00966C',
  700: '#007352',
  800: '#00523A',
  900: '#00402d'
};
